module.exports = __webpack_public_path__ + "img/logo-ndapp.1d2adb4a.svg";